module.exports = __webpack_public_path__ + "static/media/dark3Single.9decce0a.JPG";